import { usePunditUserContext } from "@circle-react/contexts";

export const useEventsFeatureFlags = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return {
    hasSplitRecurringEventsEnabled:
      !!currentCommunitySettings?.split_recurring_events_enabled,
    hasPublicEventRsvpEnabled:
      !!currentCommunitySettings?.public_event_rsvp_enabled,
  };
};
